import { store, storeFuns, api, apiFuns, utils } from "sw-hic";

storeFuns.init({
  state: {
    enum: {
      DataBaseType: ["SQLServer", "Oracle", "MySQL", "PostgreSQL"],
      ResultType: ["对象", "列表", "分页列表"],
      SqlCode: ["hic", "patient", "ml"],
      SqlItemType: ["string", "int", "object", "list"],
      PageLayout: ["检索框", "纵向", "横向"],
    },
    userRoles: null,
  },
  getters: {
    userRoles: storeFuns.genGetter("userRoles"),
  },
  mutations: {
    setUserRoles: storeFuns.genMutation("userRoles"),
  },
});
storeFuns.genDict("WebPage", () => apiFuns.genStandard("page", "/api/datacenter", true).query());
storeFuns.genDict("DataLink", () => apiFuns.genStandard("dbCon", "/api/datacenter", true).query());
storeFuns.genDict("WebModule", () => apiFuns.genStandard("module", "/api/datacenter", true).query());
export default store;
